import moment, { Moment } from "moment";
import { ar, enUS, hi, id, th, uk, vi } from "date-fns/locale";
import { ModulesTagName } from "../utils/enums";
import { ModuleProxy } from "@me-team/host/main/graphql/types";

export const hexToRgbaWithOpacity = (hex: string) => {
    const hexColor = hex;
    let rgbaColor = ``;
    if (hexColor) {
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);
        const alpha = 0.1;
        rgbaColor = `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return rgbaColor;
};

export const formatDate = (date: string | Date | Moment): string => {
    return moment(date).format("YYYY-MM-DD");
};

const capitalizeFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const withCapitalizedMonths = (locale: Locale): Locale => ({
    ...locale,
    localize: {
        ...locale.localize,
        month: (n, options) => {
            const original = locale.localize.month(n, options);
            return capitalizeFirst(original);
        },
    },
});
export const locales: Record<string, Locale> = {
    uk: withCapitalizedMonths(uk),
    vi: vi,
    ar: ar,
    hi: hi,
    id: id,
    th: th,
    en: enUS,
};

export const isWarehouseActive = (modulesList: ModuleProxy[]): boolean => {
    const warehouseModule = modulesList.find((module) => module.name === ModulesTagName.WAREHOUSES);
    return warehouseModule ? warehouseModule.active : false;
};

export const formatWhatsAppPath = (value: string): string => {
    if (!value) return null;
    const trimmed = value.trim();
    const waRegex = /^https:\/\/wa\.me\/\d+$/;
    if (waRegex.test(trimmed)) {
        return trimmed;
    }
    const cleanedNumber = trimmed.replace(/\D/g, "");
    return `https://wa.me/${cleanedNumber}`;
};
